const topics = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20comic%20scene%20massive%20spaceship%20battle%20above%20ringed%20planet%20laser%20beams%20explosions%20dramatic%20lighting%20comic%20art%20style%20warm%20orange%20explosions%20against%20dark%20space%20detailed%20illustration%20cinematic&width=800&height=500&seq=carousel-topic-1&orientation=landscape',
    tag: '星际战争',
    title: '银河帝国反击战 · 年度最燃太空史诗',
    desc: '人类联邦与外星帝国在猎户座旋臂展开终极对决，百艘星舰列阵对轰',
    date: '连载中 · 每周三更新',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20illustration%20lone%20astronaut%20exploring%20abandoned%20alien%20ruins%20on%20desert%20planet%20mysterious%20glowing%20artifacts%20ancient%20civilization%20dusty%20atmosphere%20warm%20golden%20light%20comic%20art%20style%20detailed&width=800&height=500&seq=carousel-topic-2&orientation=landscape',
    tag: '深空探索',
    title: '深渊遗迹 · 失落的远古文明苏醒',
    desc: '一支科考队在银河边缘发现超古代遗迹，沉睡万年的智慧即将觉醒',
    date: '连载中 · 每周五更新',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20art%20futuristic%20city%20on%20Mars%20red%20planet%20colony%20glass%20domes%20flying%20vehicles%20twin%20suns%20setting%20warm%20orange%20sky%20detailed%20buildings%20vibrant%20colors%20comic%20style&width=800&height=500&seq=carousel-topic-3&orientation=landscape',
    tag: '火星殖民',
    title: '红色家园 · 人类第二母星的诞生',
    desc: '第一批火星移民者在恶劣环境中建造家园，揭开火星地下的惊天秘密',
    date: '连载中 · 每周一更新',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20scene%20alien%20jungle%20planet%20giant%20bioluminescent%20plants%20strange%20creatures%20explorers%20in%20hazmat%20suits%20mysterious%20atmosphere%20green%20purple%20glow%20detailed%20illustration&width=800&height=500&seq=carousel-topic-4&orientation=landscape',
    tag: '异星生物',
    title: '绿境幻影 · 潘多拉星的致命美丽',
    desc: '生物学家团队发现一颗充满奇异生命的星球，美丽背后隐藏致命威胁',
    date: '连载中 · 每周四更新',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20art%20massive%20space%20station%20interior%20busy%20trading%20hub%20diverse%20alien%20species%20neon%20signs%20cyberpunk%20aesthetic%20warm%20amber%20lighting%20crowded%20marketplace%20detailed%20illustration&width=800&height=500&seq=carousel-topic-5&orientation=landscape',
    tag: '星际贸易',
    title: '星港风云 · 银河最大贸易站的暗流',
    desc: '在银河系最大的中转站，商人、走私者与赏金猎人的命运在此交错',
    date: '连载中 · 每周六更新',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comic%20illustration%20time%20travel%20portal%20swirling%20energy%20vortex%20scientists%20in%20futuristic%20lab%20watching%20in%20awe%20chronological%20anomalies%20warm%20golden%20light%20from%20portal%20dramatic%20composition&width=800&height=500&seq=carousel-topic-6&orientation=landscape',
    tag: '时空穿越',
    title: '时间裂隙 · 穿越平行宇宙的冒险',
    desc: '物理学家的实验意外打开时空裂隙，一支小队被送往截然不同的平行地球',
    date: '连载中 · 每周二更新',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            本周最受关注的热门作品，精彩不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#carousel"
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-accent-300/50 transition-colors no-underline block cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={topic.image}
                  alt={topic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {topic.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1.5 leading-snug group-hover:text-primary-600 transition-colors">
                  {topic.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-2">
                  {topic.desc}
                </p>
                <p className="text-xs text-foreground-400 whitespace-nowrap">
                  {topic.date}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}